import { red } from "@mui/material/colors";
import { alpha, getContrastRatio } from "@mui/material";

// https://coolors.co/002366-2a317e-aed0e6-fdec4f-e7c542-af2b2b-2b272e-464249-605c64-f5f5f5

const getPaletteColor = (baseColor, forceTextColor = null) => {
    const mainColor = alpha(baseColor, 0.8);
    return {
        main: mainColor,
        light: alpha(baseColor, 0.6),
        dark: alpha(baseColor, 1.0),
        contrastText: Boolean(forceTextColor) ? forceTextColor : (
            getContrastRatio(mainColor, "#FFFFFF") > 4.5 ? "#FFFFFF" : "#000000"
        ),
    }
}

const getPalette = () => {
    return {
        // main colors
        primary: { main: "#2D2E83" },
        secondary: { main: "#AED0E6" },
        error: { main: "#AF2B2B" },

        // custom colors
        raisinBlack: getPaletteColor("#2B272E"),
        davysGray: getPaletteColor("#605C64"),
        whiteSmoke: getPaletteColor("#F5F5F5"),
        maize: getPaletteColor("#FDEC4F"),
        saffron: getPaletteColor("#E7C542"),
        fireBrick: getPaletteColor("#AF2B2B"),
        white: getPaletteColor("#FFFFFF"),
        resolutionBlue: getPaletteColor("#2A317E"),

        // payments
        // paymentCompleted: getPaletteColor("#00AC00"),
        paymentPaid: getPaletteColor("#78AC89"),
        paymentBlank: getPaletteColor("#EBEBEB"),
        paymentMissing: getPaletteColor("#FF0000", "#FFFFFF"),
        paymentSkipped: getPaletteColor("#464646"),
        // paymentMultiple: getPaletteColor("#FFFFAA"),

        background: {
            default: "#FFFFFF",
        },

        text: {
            primary: "#2B272E",
            secondary: "#464249",
            disabled: "#605C64",
        },
    }
}

export default getPalette;
